/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// material-ui icons
import Email from '@material-ui/icons/EmailOutlined';
import Phone from '@material-ui/icons/PhoneOutlined';
import PhoneAndroid from '@material-ui/icons/PhoneAndroid';
import Person from '@material-ui/icons/PersonOutlined';
// our components
import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles';
import CardBody from 'components/UI/Card/CardBody';
import GridItem from 'components/UI/Grid/GridItem';
import Card from 'components/UI/Card/Card';
import UserInfo from 'components/User/Info';
import GridContainer from 'components/UI/Grid/GridContainer';
import { phoneTypes, phoneWhatsapp } from 'config';

/**
 * @description
 * Stateless component.
 *
 * @param {Object} props - Component props.
 */
const AdUser = ({ data, classes, t }) => (
  <GridContainer>
    <GridItem xs={12} sm={6} md={12}>
      {data.ad.user && <UserInfo id={data.ad.user.id} data={data.ad.user} />}
    </GridItem>
    <GridItem xs={12} sm={6} md={12}>
      <Card>
        <CardBody>
          <h6>{t('ad.details.info')}</h6>
          {data.ad.name && (
            <p
              className={`${classes.verticalAlignment}
                      ${classes.infoContact}`}
            >
              <Person />
              <span data-cy="adUserName">{data.ad.name}</span>
            </p>
          )}
          {data.ad.email && (
            <p
              data-cy="adUserEmail"
              className={`${classes.verticalAlignment}
                          ${classes.infoContact}`}
            >
              <Email />
              <span>{data.ad.email}</span>
            </p>
          )}
          {data.ad.firstPhone && (
            <p
              data-cy="adUserPhone"
              className={`${classes.verticalAlignment}
                        ${classes.infoContact}`}
            >
              {data.ad.firstPhoneType === phoneTypes.CELLPHONE ? (
                <PhoneAndroid />
              ) : (
                <Phone />
              )}
              <span>{`${data.ad.firstPhonePrefix}${data.ad.firstPhone}`}</span>
              {data.ad.whatsapp === phoneWhatsapp.FIRST_PHONE && (
                <span>(Whatsapp)</span>
              )}
            </p>
          )}
          {data.ad.secondPhone && (
            <p
              data-cy="adUserPhone"
              className={`${classes.verticalAlignment}
                        ${classes.infoContact}`}
            >
              {data.ad.secondPhoneType === phoneTypes.CELLPHONE ? (
                <PhoneAndroid />
              ) : (
                <Phone />
              )}
              <span>{`${data.ad.secondPhonePrefix}${data.ad.secondPhone}`}</span>
              {data.ad.whatsapp === phoneWhatsapp.SECOND_PHONE && (
                <span>(Whatsapp)</span>
              )}
            </p>
          )}
        </CardBody>
      </Card>
    </GridItem>
  </GridContainer>
);

/**
 * AdInfo PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop user info received from parents
 * @param t - prop from HOC with string translations
 */

AdUser.propTypes = {
  data: PropTypes.shape({}).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(userProfileStyles)(AdUser));
